import {FC, ChangeEvent, useState, useRef, useEffect} from 'react'
import {Spinner} from 'react-bootstrap'
import {ArrowRightShort, EyeFill, EyeSlashFill} from 'react-bootstrap-icons'
import {authStyles} from '../layout/authStyles.ts'
import useIsMobile from '../../hooks/useIsMobile'

interface AuthPasswordInputProps {
    value: string
    onChange: (e: ChangeEvent<HTMLInputElement>) => void
    onBlur?: () => void
    placeholder: string
    testId?: string
    autoComplete?: string
    minLength?: number
    showSubmitButton?: boolean
    submitDisabled?: boolean
    isLoading?: boolean
    submitAriaLabel?: string
    autoFocusOnDesktop?: boolean
}

const AuthPasswordInput: FC<AuthPasswordInputProps> = ({
                                                           value,
                                                           onChange,
                                                           onBlur,
                                                           placeholder,
                                                           testId = 'password-input',
                                                           autoComplete = 'current-password',
                                                           minLength,
                                                           showSubmitButton = false,
                                                           submitDisabled = false,
                                                           isLoading = false,
                                                           submitAriaLabel = 'Submit',
                                                           autoFocusOnDesktop = false
                                                       }) => {
    const [showPassword, setShowPassword] = useState(false)
    const inputRef = useRef<HTMLInputElement>(null)
    const isMobile = useIsMobile()

    useEffect(() => {
        if (autoFocusOnDesktop && !isMobile && inputRef.current) {
            inputRef.current.focus()
        }
    }, [autoFocusOnDesktop, isMobile])

    return (
        <div className={authStyles.inputWrapper}>
            <input
                ref={inputRef}
                type={showPassword ? 'text' : 'password'}
                className={authStyles.pillInput}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                autoComplete={autoComplete}
                data-testid={testId}
                required
                minLength={minLength}
            />
            <button
                type="button"
                className={authStyles.visibilityToggle}
                onClick={() => setShowPassword(!showPassword)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
            >
                {showPassword ? <EyeFill/> : <EyeSlashFill/>}
            </button>
            {showSubmitButton && (
                <button
                    type="submit"
                    className={authStyles.circularSubmit}
                    disabled={submitDisabled || isLoading}
                    aria-label={submitAriaLabel}
                    data-testid="auth-submit-button"
                >
                    {isLoading ? (
                        <Spinner size="sm" animation="border"/>
                    ) : (
                        <ArrowRightShort/>
                    )}
                </button>
            )}
        </div>
    )
}

export default AuthPasswordInput
